import React, { type FC } from 'react';
import * as util from '#packages/util';
import { ToggleSwitch } from '@wix/wix-base-ui';
import type { MapStateToProps } from 'types/redux';
import styles from './devModeToggle.scss';

export interface DevModeToggleStateProps {
  isDevModeEnabled: boolean;
}
interface DevModeToggleProps {
  toggle: () => void;
  isDevModeEnabled: boolean;
}

const DevModeToggle: FC<DevModeToggleProps> = ({
  toggle,
  isDevModeEnabled,
}: DevModeToggleProps) => (
  <div
    className={styles.devModeToggleContainer}
    onClick={(e) => {
      e.stopPropagation();
    }}
  >
    <ToggleSwitch
      automationId={isDevModeEnabled ? 'code-btn-code-off' : 'code-btn-code-on'}
      className={styles.devModeToggle}
      size="MEDIUM"
      onChange={() => toggle()}
      value={isDevModeEnabled}
    />
  </div>
);

export const mapStateToProps: MapStateToProps<DevModeToggleStateProps> = ({
  editorAPI,
}) => ({
  isDevModeEnabled: editorAPI.developerMode.isEnabled(),
});

export default util.hoc.connect(
  util.hoc.STORES.EDITOR_API,
  mapStateToProps,
  null,
)(DevModeToggle);
